<template>
  <div class="tw-flex tw-grid tw-grid-cols-1 md:tw-grid-cols-2 tw-capitalize">
    <div class="tw-flex tw-items-center tw-mt-3">
      <img src="/images/icons/car1.png" class="tw-w-12 tw-h-12" alt="tow">
      <div class="tw-ml-3">
        <small class="tw-mt-2 c-gray-text">Third party person liability</small>
        <p class="tw-text-xs c-blue-text">Free limit; Any One Person KSH 3,000,000</p>
      </div>
    </div>
    <div class="tw-flex tw-items-center tw-mt-3">
      <img src="/images/icons/car3.png" class="tw-w-12 tw-h-12" alt="tow">
      <div class="tw-ml-3">
        <small class="tw-mt-2 c-gray-text">Passengers liability</small>
        <p class="tw-text-xs c-blue-text">Free limit; Any Person KSH 4,000,000/Any One Event KES 20,000,000</p>
      </div>
    </div>
    <div class="tw-flex tw-items-center tw-mt-3">
      <img src="/images/icons/hit.png" class="tw-w-12 tw-h-12" alt="tow">
      <div class="tw-ml-3">
        <small class="tw-mt-2 c-gray-text">Third party property damage</small>
        <p class="tw-text-xs c-blue-text">Free limit KSH 5,000,000</p>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'ThirdPartyBenefits',
};
</script>
